import React, { useState } from "react";

import ConfirmModal from "@src/components/popup/ConfirmModal";
import { css } from "@emotion/react";
import { useSearchParams } from "react-router-dom";

interface Props {
    deviceType: "ios" | "android";
}

const SubscriptionDesc: React.FC<Props> = ({ deviceType }) => {
    const [searchParams] = useSearchParams();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [modalContents, setModalContents] = useState<any>(<div />);

    const onChangeModalContents = (title: string) => {
        switch (title) {
            case "실거래가":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>실거래가</p>
                        <p css={messageStyle}>매일 업데이트 되는 전국 실거래가를 확인할 수 있어요</p>
                    </>,
                );
            case "데이터맵":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>데이터맵</p>
                        <p css={messageStyle}>경공매, 실거래 마커를 통해 부동산 정보를 한눈에 볼 수 있어요</p>
                    </>,
                );
            case "AI추천매물":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>AI추천</p>
                        <p css={messageStyle}>
                            투자금을 입력하면 세금 및 대출 비중을 고려하여 매물을 추천해드려요 설정한 조건에 맞는 매물이
                            업데이트되면 알려드려요
                        </p>
                    </>,
                );
            case "소액투자":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>소액투자</p>
                        <p css={messageStyle}>소액도 상관없어요 투자금을 입력하면 최적의 매물을 찾아드려요</p>
                    </>,
                );
            case "Go-Stop":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>Go-Stop</p>
                        <p css={messageStyle}>권리분석, 시세 등을 분석하여 입찰을 Go 또는 Stop 할지 AI가 판단해드려요</p>
                    </>,
                );
            case "국•공유지 필터":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>국•공유지 필터</p>
                        <p css={messageStyle}>데이터맵에서 간편하게 국공유지 정보를 파악할 수 있어요</p>
                    </>,
                );
            case "확장예정 도로 데이터맵":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>확장예정 도로 데이터맵</p>
                        <p css={messageStyle}>도로 확장 또는 신설 예정인 토지를 미리 확인할 수 있어요.</p>
                    </>,
                );
            case "실시간 건축대장열람":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>실시간 건축대장열람</p>
                        <p css={messageStyle}>건축물대장을 실시간으로 열람할 수 있어요</p>
                    </>,
                );
            case "실시간 등기열람":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>실시간 등기열람</p>
                        <p css={messageStyle}>
                            부동산 등기를 실시간으로 열람하고 미스고에서 3개월 동안 보관하여 관리할 수 있어요 실시간 열람 시
                            열람권 1장이 소모돼요
                        </p>
                    </>,
                );
            case "기존 등기열람":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>기존 등기열람</p>
                        <p css={messageStyle}>미스고에 수집된 등기를 열람할 수 있는 기능</p>
                    </>,
                );
            case "동시접속":
                return setModalContents(
                    <>
                        <p css={messageTitleStyle}>동시접속</p>
                        <p css={messageStyle}>하나의 아이디로 동시 접속 가능한 PC, APP 기기 수 정보에 대해 알려드릴게요</p>
                    </>,
                );
            default:
                return setModalContents(<div />);
        }
    };

    const pricingList = {
        func: [
            {
                title: <div css={titleTextStyle}>연 이용료</div>,
                firstContent: (
                    <div style={{ fontWeight: "bold", color: "#000" }}>{deviceType === "ios" ? "43만 9천원" : "41만 2천원"}</div>
                ),
                secondContent: (
                    <div style={{ fontWeight: "bold", color: "#000" }}>{deviceType === "ios" ? "29만 9천원" : "33만원"}</div>
                ),
                thirdContent: <div>90만원대</div>,
                fourthContent: <div>50 ~ 60만원</div>,
                fifthContent: <div>25만원</div>,
            },
            {
                title: <div css={titleTextStyle}>미스고 AI 챗봇</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>❌</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>매각결과 카톡 푸쉬 알람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>❌</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>미스고 AI 경매 길잡이</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>원터치 실시간 부동산 등기 열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>원터치 실시간 법인 등기 열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>원터치 실시간 토지 대장 열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>원터치 실시간 건축물 대장 열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>소유자 확인 가능</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>터치지도기반 필지 검색</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>국유지 열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>앱 모바일 유무(애플,삼성)</div>,
                firstContent: <div>✅ 애플, 삼성</div>,
                secondContent: <div>삼성</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
                fifthContent: <div>❌</div>,
            },
        ],
    };
    //* 설명 리스트로 작업
    const descList = {
        info: [
            {
                title: "연 이용료",
                firstContent: (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "25px", fontWeight: "700", color: "#FF0000" }}>
                            {deviceType === "ios" ? "43만원" : "41만원"}
                        </span>
                    </div>
                ),
                secondContent: (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "25px", fontWeight: "700", color: "#FF0000" }}>
                            {deviceType === "ios" ? "29만원" : "33만원"}
                        </span>
                    </div>
                ),
                thirdContent: <div>{deviceType === "ios" ? "28만원" : "25만원"}</div>,
                fourthContent: <div>{deviceType === "ios" ? "27만원" : "24만원"}</div>,
            },
        ],
        func: [
            {
                title: <div css={titleTextStyle}>미스고 AI 챗봇</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>❌</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>매각결과 카톡 푸쉬 알람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>❌</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>미스고 AI 경매 길잡이</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>전국 경•공매 정보열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>터치 방식 데이터 맵</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>AI 추천</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>Go-Stop 투자분석</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>매일 업데이트되는 실거래가</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>입찰대리 전문가 매칭 (유료)</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>원터치 실시간 부동산 등기 열람 (유료)</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>✅</div>,
            },
            {
                title: <div css={titleTextStyle}>기존 등기 열람 무제한 열람</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>실시간 등기열람권 매월 3장 무료 제공</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>도로확장 전체 데이터맵 1년 이용권 (제주 한정)</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>경매 캠퍼스 무제한 1달 수강</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>✅</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>국•공유지 필터</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>주거/토지 수익 필터</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>상가 예상 수익률 Go-Stop</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>소유자 확인 이용권 - 기본 10장 (25년 5월부터)</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>토지대장•임야대장 무료 열람 - 하루 20장 무료</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>건축물대장 무료 열람 - 하루 20장 무료</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
            {
                title: <div css={titleTextStyle}>VIP 전용 고객지원 서비스</div>,
                firstContent: <div>✅</div>,
                secondContent: <div>✅</div>,
                thirdContent: <div>❌</div>,
                fourthContent: <div>❌</div>,
            },
        ],
    };

    return (
        <>
            <div css={rootBoxStyle}>
                <div css={titleBoxStyle}>📊 경쟁사 비교 📊</div>
                <div css={contentRootBoxStyle}>
                    <table>
                        <colgroup>
                            <col width="auto" />
                            <col width="21%" />
                            <col width="21%" />
                            <col width="14%" />
                            <col width="14%" />
                            <col width="14%" />
                        </colgroup>
                        <thead>
                            <tr css={tableHeadStyle}>
                                <th />
                                <th style={{ color: "#F6494B" }}>미스고 VVIP Full</th>
                                <th style={{ color: "#5F0080" }}>미스고 VIP Full</th>
                                <th>A사</th>
                                <th>타사경매</th>
                                <th>저가경매</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={4} css={tableSubTitleStyle}>
                                    비교안내
                                </td>
                            </tr>
                            {pricingList.func.map((content, idx) => (
                                <tr className="basicTr" key={content.title.toString()}>
                                    <td>
                                        <div className={idx === 1 || idx === 2 || idx === 3 ? "AiHighLight" : ""}>
                                            {content.title}
                                        </div>
                                    </td>
                                    <td>{content.firstContent}</td>
                                    <td>{content.secondContent}</td>
                                    <td>{content.thirdContent}</td>
                                    <td>{content.fourthContent}</td>
                                    <td>{content.fifthContent}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div css={titleBoxStyle} style={{ marginTop: "24px" }}>
                    📊
                    <span className="purpleText">미스고</span>VIP 요금제 비교표
                </div>
                <div css={contentRootBoxStyle}>
                    <table>
                        <colgroup>
                            <col width="30%" />
                            <col width="17.5%" />
                            <col width="17.5%" />
                            <col width="17.5%" />
                        </colgroup>
                        <thead>
                            <tr css={tableHeadStyle}>
                                <th />
                                <th style={{ color: "#F6494B" }}>VVIP Full</th>
                                <th style={{ color: "#0047FF" }}>VIP Full</th>
                                <th style={{ color: "#5F0080" }}>VIP Lite</th>
                                <th style={{ color: "#FF9500" }}>베이직</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={4} css={tableSubTitleStyle}>
                                    가격
                                </td>
                            </tr>
                            {descList.info.map((content) => (
                                <tr className="basicTr" key={content.title.toString()}>
                                    <td>{content.title}</td>
                                    <td>{content.firstContent}</td>
                                    <td>{content.secondContent}</td>
                                    <td>{content.thirdContent}</td>
                                    <td>{content.fourthContent}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tbody>
                            <tr>
                                <td colSpan={3} css={tableSubTitleStyle}>
                                    기능
                                </td>
                            </tr>
                            {descList.func.map((content, idx) => (
                                <tr className="basicTr" key={idx.toString()}>
                                    <td>
                                        <div className={idx === 1 || idx === 2 || idx === 0 ? "AiHighLight" : ""}>
                                            {content.title}
                                        </div>
                                    </td>
                                    <td>{content.firstContent}</td>
                                    <td>{content.secondContent}</td>
                                    <td>{content.thirdContent}</td>
                                    <td>{content.fourthContent}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {!!openModal && (
                <ConfirmModal
                    resultMessage={modalContents}
                    onConfirm={() => {
                        setOpenModal(false);
                        setModalContents(<div />);
                    }}
                />
            )}
        </>
    );
};

export default SubscriptionDesc;

const rootBoxStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 60px;
`;

const titleBoxStyle = css`
    text-align: center;
    padding-bottom: 24px;
    color: #0c002c;
    font-size: 24px;
    font-weight: 700;
    line-height: 34px;

    .purpleText {
        color: #5f0080;
        margin-left: 8px;
        margin-right: 8px;
    }
`;

const contentRootBoxStyle = css`
    border: 0.6px solid #c9c9c9;
    border-radius: 4px;
    width: calc(100% - 28px);
    overflow-x: auto;
    box-sizing: border-box;
    table {
        width: 100%;
        min-width: 600px;
        border-collapse: collapse;
        vertical-align: middle;
        tbody {
            vertical-align: middle;
        }
        td {
            vertical-align: middle;
        }
        .basicTr > td {
            &:first-of-type {
                text-align: left;
                padding-left: 14px;
            }
            box-sizing: border-box;
            border-bottom: 0.6px solid #c9c9c9;
            padding: 8px 4px;
            text-align: center;
            color: #0c002c;
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
        }

        .AiHighLight {
            width: 180px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 4px 0;
            background-color: #000;
            color: #fff !important;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;

            & > div {
                color: #fff;
            }
        }
    }
`;

const tableHeadStyle = css`
    text-align: center;
    color: #0047ff;
    background-color: #dff0ff;
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
    vertical-align: middle;
    th {
        padding: 4px;
        box-sizing: border-box;
    }
    th:first-of-type {
        border-radius: 4px 0 0 4px;
    }
    th:last-of-type {
        border-radius: 0 4px 4px 0;
        word-break: break-word;
        white-space: pre-wrap;
    }
`;

const tableSubTitleStyle = css`
    text-align: left;
    color: #0c002c;
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
    padding: 8px 14px;
`;

const deunggiGiveStyle = css`
    color: #0047ff;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
`;

const duplicateTextStyle = css`
    color: #0c002c;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
`;

const grayTextStyle = css`
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #8d8d8d;
`;

const titleTextStyle = css`
    display: inline-flex;
    align-items: center;
    position: relative;
    color: #0c002c;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;

    gap: 4px;
`;

const newTextStyle = css`
    background-color: #faff00;
    display: inline-block;
`;

const messageTitleStyle = css`
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    margin-bottom: 8px;
`;

const messageStyle = css`
    color: #3c3c3c;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    word-break: break-all;
`;
